export default __webpack_public_path__ + "static/media/avatar-s-18.565bb1fd.jpg";